module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8BCqG7/Images/MSRCover.jpg?1740318085764",
      "alt": "This image is the cover for the book Substitute Bride"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Substitute Bride\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Fleeing an arranged marriage, debutante Elizabeth Manning exchanges places with a mail-order bride bound for New Harmony, Iowa. Life on the frontier can't be worse than forced wedlock to pay her father's gambling debts. But Ted Logan's rustic lifestyle and rambunctious children prove to be more of a challenge than Elizabeth expects. She doesn't know how to be a mother or a wife. She doesn't even know how to tell Ted the truth about her past—especially as her feelings for him grow. Little does she know, Ted's hiding secrets of his own, and when their pasts collide, there's more than one heart at stake."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Janet Dean\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Janet Dean married her college sweetheart and taught first grade before leaving to rear two daughters. As her daughters grew, they watched Little House on the Prairie, reawakening Janet’s love of American history and the stories of strong men and women of faith who built this country. Janet eagerly turned to writing inspirational historical romance. When she isn’t writing, Janet stamps greeting cards, plays golf and bridge, and is never without a book to read.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0